import React from 'react';
import PropTypes from 'prop-types';

const Sort = ({
  totalItems = 0,
  currentItems = [],
  sortBy = 'default',
  setSortBy = () => {}
}) => {
  const items = Array.isArray(currentItems) ? currentItems : [];

  return (
    <div className="cs_sort_wrapper">
      <div className="cs_sort_results">
        Showing {items.length} of {totalItems || 0} results
      </div>
      <select
        value={sortBy}
        onChange={(e) => setSortBy(e.target.value)}
        className="cs_select"
      >
        <option value="default">Default sorting</option>
        <option value="price-low-high">Price: Low to High</option>
        <option value="price-high-low">Price: High to Low</option>
        <option value="name">Name</option>
        <option value="rating">Rating</option>
      </select>
    </div>
  );
};

Sort.propTypes = {
  totalItems: PropTypes.number,
  currentItems: PropTypes.array,
  sortBy: PropTypes.string,
  setSortBy: PropTypes.func
};

export default Sort;
